import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from '../../app/store';

export const filterAndSort = (faqs: Faq[], audience: string): Faq[] => {
//  if (category) {
//    return faqs.filter(f => f.audience === audience && f.category === category).sort((a,b) => a.faqOrder - b.faqOrder);
//  } else {
    return faqs.filter(f => f.audience === audience).sort((a,b) => a.faqOrder - b.faqOrder);
//  }
}

export const findOrderNumber = (faqs: Faq[], id: string, audience: string): number => {
  return filterAndSort(faqs, audience).find(f => id === f.id)?.faqOrder as number;
}

export const findDecrementOrderNumbers = (faqs: Faq[], orderNumber: number, audience: string): Faq[] => {
  return filterAndSort(faqs, audience).filter(faq => orderNumber < faq.faqOrder);
}

export const reduceOrderInList = (faqs: Faq[], faq: Faq, audience: string): {rise: Faq, lower: Faq} => {
  let risen: Faq = {} as Faq;
  let lowered: Faq = {} as Faq;
  const actionFaqOrder = findOrderNumber(faqs, faq.id, audience);
  if (actionFaqOrder !== 0) {
    faqs.forEach(f => {
      const f_copy = structuredClone(f)
      if (f.faqOrder === actionFaqOrder - 1 && f.audience === audience) {
        // get the f that is lower in order (the one above the current in the list),  and increase its order
        f_copy.faqOrder = f_copy.faqOrder + 1;
        risen = f_copy;
      } else if (f.faqOrder === actionFaqOrder && f.audience === audience) {
        // otherwise find the current faq in list f and reduce its order
        f_copy.faqOrder = f_copy.faqOrder - 1;
        lowered = f_copy;
      }
    });
  }

  return {rise: risen, lower: lowered};
}

export const increaseOrderInList = (faqs: Faq[], faq: Faq, audience: string): {rise: Faq, lower: Faq} => {
  let risen: Faq = {} as Faq;
  let lowered: Faq = {} as Faq;

  const actionFaqOrder = findOrderNumber(faqs, faq.id, audience);
  if (actionFaqOrder !== faqs.length - 1) {
    faqs.forEach(f => {
      const f_copy = structuredClone(f)
      if (f.faqOrder === actionFaqOrder + 1 && f.audience === audience) {
        // get the f that is higher in order (the one below the current in the list),  and reduce its order
        f_copy.faqOrder = f_copy.faqOrder - 1;
        lowered = f_copy;
      } else if (f.faqOrder === actionFaqOrder && f.audience === audience) {
        // otherwise find the current faq in list f and increase its order
        f_copy.faqOrder = f_copy.faqOrder + 1;
        risen = f_copy;
      }
    });
  }

  return {rise: risen, lower: lowered};
}


export interface Faq {
  id: string,
  author: string,
  created: string,
  updated: string,
  faqOrder: number,
  question: string,
  answer: string,
  audience: 'general' | 'vendors',
  category: string
}
export interface FaqState {
  faq: Faq,
  faqs: Faq[]
  generalCats: string[]
  vendorCats: string[]
  faqOrderValue: number
  status: 'idle' | 'pending' | 'succeeded' | 'failed',
  error: null | string
}

export interface FaqApiPayload {
  accessToken: string
  id: null | string
  faq: null | Faq,
}

const initialState: FaqState = {
  faq: null,
  faqs: [],
  faqOrderValue: 0,
  status: 'idle',
  error: null
} as unknown as FaqState;

export const fetchFaqs = createAsyncThunk<Faq[], void, { readonly rejectValue: { readonly errorMessage: string } }>(
  'faqs/fetch',
  async (_, thunkAPI) => {
    return await fetch(
      '/api/faqs/',
      {
        method: 'GET',
      })

      .then(response => {
        if (response.status === 200) {
            return response.json();
        } else {
            throw new Error(`Unexpected response from server (code ${response.status}).`);
        }
      })

      .catch((error) => {
        console.error(error);
        return thunkAPI.rejectWithValue({ errorMessage: error.message });
      });
  }
);

export const fetchFaqCats = createAsyncThunk<string[], string, { readonly rejectValue: { readonly errorMessage: string } }>(
  'faq/cats/fetch',
  async (arg, thunkAPI) => {
    console.log(arg)
    return await fetch(
      `/api/faqs/cats/${arg}`,
      {
        method: 'GET'
      })

      .then(response => {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error(`Unexpected response from server (code ${response.status}).`);
        }
      })

      .catch( (error) => {
        console.error(error);
        return thunkAPI.rejectWithValue({ errorMessage: error.message });
      });
  }
);

export const fetchFaq = createAsyncThunk<Faq, FaqApiPayload, { readonly rejectValue: { readonly errorMessage: string } }>(
  'faq/fetch',
  async (arg, thunkAPI) => {
    return await fetch(
      `/api/faqs/${arg.id}`,
      {
          method: 'GET',
      })

      .then(response => {
        if (response.status === 200) {
            return response.json();
        } else {
            throw new Error(`Unexpected response from server (code ${response.status}).`);
        }
      })

      .catch((error) => {
        console.error(error);
        return thunkAPI.rejectWithValue({ errorMessage: error.message });
      });
  }
);

export const createFaq = createAsyncThunk<Faq, FaqApiPayload, { rejectValue: { readonly errorMessage: string, readonly faq: FaqApiPayload } }>(
  'faq/create',

  async (arg, thunkAPI) => {

    if (!arg.faq) {
      throw new Error(`No faq in request.`);
    }

    return await fetch(
      '/api/faqs/',
      {
        method: 'POST',
        body: JSON.stringify(arg.faq),
        ...(arg.accessToken ? {headers: { Authorization: `Basic ${arg.accessToken}`}} : {})
      })

      .then(response => {
        if (response.status === 200) {
            return response.json();
        } else {
            throw new Error(`Unexpected response from server (code ${response.status}).`);
        }
      })

      .catch((error) => {
        console.error(error);
        return thunkAPI.rejectWithValue({ errorMessage: error.message, faq: arg });
      });
  }
);

export const editFaq = createAsyncThunk<Faq, FaqApiPayload, { rejectValue: { readonly errorMessage: string, readonly faqApiPayload: FaqApiPayload } }>(
  'faq/edit',

  async (arg, thunkAPI) => {

    if (!arg.faq) {
      throw new Error(`No faq in request.`);
    }

    return await fetch(
      '/api/faqs/',
      {
        method: 'PATCH',
        body: JSON.stringify(arg.faq),
        ...(arg.accessToken ? {headers: { Authorization: `Basic ${arg.accessToken}`}} : {})
      })

      .then(response => {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error(`Unexpected response from server (code ${response.status}).`);
        }
      })

      .catch((error) => {
        console.error(error);
        return thunkAPI.rejectWithValue({ errorMessage: error.message, faqApiPayload: arg });
      });
  }
);


export const deleteFaq = createAsyncThunk<string, FaqApiPayload, { rejectValue: { readonly errorMessage: string } }>(
  'faq/delete',

  async (arg, thunkApi) => {

    return await fetch(
      `/api/faqs/${arg.id}`,
      {
        method: 'DELETE',
        body: JSON.stringify(arg.faq),
        ...(arg.accessToken ? {headers: { Authorization: `Basic ${arg.accessToken}`}} : {})
      })

      .then(response => {
        if (response.status === 200) {
          return '' + response.body;
        } else {
          throw new Error(`Unexpected response from server (code ${response.status}).`);
        }
      })

      .catch((error) => {
        console.error(error);
        return thunkApi.rejectWithValue({ errorMessage: error.message });
      });
  }
);


export const faqSlice = createSlice({
  name: 'faqstate', // not sure what this 'name' is for. For the moment, I'll just call it the same as the reference in store.ts
  initialState,
  reducers: {
    reset: () => initialState,
    setStatus: (state, action: {type: string, payload: 'idle' | 'pending' | 'succeeded' | 'failed'}) => {
      state.status = action.payload;
    },
    setFaqOrderValue: (state, action: {type: string, payload: number}) => {
      state.faqOrderValue = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFaqs.pending, (state, action) => {
        state.status = 'pending';
      })
      .addCase(fetchFaqs.fulfilled, (state, action) => {
        state.faqs = action.payload.sort((a,b) => a.faqOrder - b.faqOrder);
        state.error = '';
        state.status = 'succeeded';
      })
      .addCase(fetchFaqs.rejected, (state, action) => {
        state.status = 'failed';
      })

      .addCase(fetchFaqCats.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(fetchFaqCats.fulfilled, (state, action) => {
        console.log(action.payload)
        console.log(action.meta.arg)
        if (action.meta.arg === 'vendors') {
          state.vendorCats = action.payload; 
        } else {
          state.generalCats = action.payload; 
        }
        state.error = '';
        state.status = 'succeeded';
      })
      .addCase(fetchFaqCats.rejected, (state, action) => {
        state.status = 'failed';
      })

      .addCase(fetchFaq.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(fetchFaq.fulfilled, (state, action) => {
        state.faq = action.payload;
        state.error = '';
        state.status = 'succeeded';
      })
      .addCase(fetchFaq.rejected, (state, action) => {
        if (action.payload !== undefined) {
            state.error = action.payload.errorMessage;
        }
        state.status = 'failed';
      })

      .addCase(createFaq.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(createFaq.fulfilled, (state, action) => {
        reset();
        state.status = 'succeeded';
      })
      .addCase(createFaq.rejected, (state, action) => {
        console.log(action.payload?.errorMessage)
        if (action.payload !== undefined) {
            state.error = action.payload.errorMessage;
        }
        state.status = 'failed';
      })

      .addCase(editFaq.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(editFaq.fulfilled, (state, action) => {
        reset();
        state.status = 'succeeded';
      })
      .addCase(editFaq.rejected, (state, action) => {
        console.log(action.payload?.errorMessage)
        if (action.payload !== undefined) {
            state.error = action.payload.errorMessage;
        }
        state.status = 'failed';
      })
      
      .addCase(deleteFaq.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(deleteFaq.fulfilled, (state, action) => {
        state.faq = {} as Faq;
        if (state.faqs.length > 0) {
          state.faqs.splice(state.faqs.findIndex(e => e.id === action.payload) , 1)
        }
        state.error = '';
        state.status = 'succeeded';
      })
      .addCase(deleteFaq.rejected, (state, action) => {
        if (action.payload !== undefined) {
            state.error = action.payload.errorMessage;
        }
        state.status = 'failed';
      })
;
},
        
});

export const {reset, setFaqOrderValue} = faqSlice.actions;

export const selectAllVendorFaqs = (state: RootState) => filterAndSort(state.faqstate.faqs,'vendors');
export const selectAllGeneralFaqs = (state: RootState) => filterAndSort(state.faqstate.faqs,'general');


export const selectAllVendorFaqCats = (state: RootState) => state.faqstate.vendorCats;
export const selectAllGeneralFaqCats = (state: RootState) => state.faqstate.generalCats;

export const selectFaqById = (state: RootState, faqId: string) =>
  state.faqstate.faqs.find(evt => evt.id === faqId)

export const selectFaqStatus = (state: RootState) => state.faqstate.status;
export const selectFaqError = (state: RootState) => state.faqstate.error;

export default faqSlice.reducer;